import { Box, Container, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { CartContext } from "./provider.js";
import { DeleteIcon } from "../icons.js";
import { makeCurrencyFormatter } from "./utils.js";
import { QuantitySelect } from "./quantity-select.js";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";
export const ItemsCardList = ({ products = [] }) => {
    const { t } = useTranslation("c-cart");
    const theme = useTheme();
    const { cart, disableInteraction, removeItem, updateItem } = React.useContext(CartContext);
    const productBySku = React.useCallback((sku) => products.find(({ ean }) => ean === sku), // product.storeId === id
    [products]);
    return (React.createElement(Container, { maxWidth: "xl" },
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", sx: { borderBottom: `2px solid ${theme.palette.divider}`, pb: 1.5 } },
            React.createElement(Typography, { component: "div", variant: "h5" }, t("label-product", "Produkt")),
            React.createElement(Typography, { component: "div", variant: "h5" }, t("label-total-amount", "Summe"))),
        cart &&
            cart?.items.map((item, ix) => {
                const { key, sku, prices, quantity, totals } = item;
                const game = productBySku(sku);
                const formatCurrency = makeCurrencyFormatter(item.prices);
                if (!game)
                    return null;
                return (React.createElement(Box, { key: item.key, sx: {
                        borderBottom: ix === cart.items.length - 1 ? "none" : `2px solid ${theme.palette.divider}`,
                        pt: 4,
                        pb: 4,
                    } },
                    React.createElement(Stack, { alignItems: "flex-start", direction: "row", spacing: 3 },
                        React.createElement(Box, { sx: {
                                boxShadow: game.edition === "online" ? "none" : "product",
                                display: "flex",
                                filter: game.edition === "online"
                                    ? "drop-shadow(12.5px 3.1px 10px rgba(0, 0, 0, 0.2))"
                                    : "none",
                                maxWidth: "34%",
                            } }, game?.coverImage && (React.createElement(Image, { ...game.coverImage, alt: game.title, style: { width: "100%", height: "auto" } }))),
                        React.createElement(Box, null,
                            React.createElement(Typography, { component: "div", variant: "h3", sx: { hyphens: "none", mt: 0 } }, game?.title ?? ""),
                            React.createElement(Typography, { component: "p", sx: { display: "flex", pt: 1, pb: 0 }, variant: "h6" },
                                t("label-unit-price", "Einzelpreis:"),
                                React.createElement("span", null,
                                    "\u00A0",
                                    formatCurrency(prices.price))))),
                    React.createElement(Stack, { direction: "row", alignItems: "baseline", justifyContent: "space-between", sx: { mt: 3 } },
                        React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 2 },
                            React.createElement(Typography, { component: "div", variant: "body1", sx: { pr: 0 } }, t("label-qty", "Anzahl")),
                            React.createElement(QuantitySelect, { "data-testid": "qty-input", disabled: disableInteraction, onChange: (quantity) => updateItem({ key, quantity }), value: item.quantity }),
                            React.createElement(IconButton, { "data-testid": "remove-item", disabled: disableInteraction, onClick: () => removeItem({ key }), size: "small" },
                                React.createElement(DeleteIcon, { fontSize: "inherit" }))),
                        React.createElement(Typography, { component: "span", sx: { display: "flex", justifyContent: "flex-end", pt: 0, pb: 0 }, variant: "h3" }, formatCurrency(parseInt(totals.line_total) + parseInt(totals.line_total_tax))))));
            })));
};
//# sourceMappingURL=items-card-list.js.map